<ng-container *appTranslate="let t">
  <p-multiselect
    #multiSelect
    [fluid]="true"
    [inputId]="inputId"
    [options]="types"
    [disabled]="disabled"
    [showToggleAll]="false"
    [showClear]="true"
    [ngModel]="model"
    (onChange)="updateModel($event.value)"
    (onClear)="updateModel(null)"
  >
    <ng-template #item let-item>
      <div class="row">
        <new-ui-activity-icon [type]="item.value" />
        <span>{{ item.value | enum: "ActivityType" }}</span>
      </div>
    </ng-template>

    <ng-template #selecteditems let-types>
      @if (!types?.length) {
        <span>{{ multiSelect.placeholder() }}</span>
      }

      @for (type of types; track type) {
        <span>
          <new-ui-activity-icon [type]="type" />
          {{ type | enum: "ActivityType" }}{{ $last ? "" : ", " }}
        </span>
      }
    </ng-template>
  </p-multiselect>
</ng-container>
